import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

export const updateDealershipMember = async (memberData) => {
  try {
    const fn = httpsCallable(functions, "updateUnitMembershipV2");
    const safeData = { ...(memberData || {}) };
    delete safeData.password;
    delete safeData.confirmPassword;
    safeData.requestedApp = "dealership_web";
    const result = await fn(safeData);
    return result.data;
  } catch (error) {
    console.error("Error updating dealership member:", error);
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: "Error al actualizar el miembro",
      error: error.message,
    };
  }
};

export const getDealershipMembers = async (data) => {
  try {
    const fn = httpsCallable(functions, "listUnitMembersV2");
    const result = await fn({ ...data, requestedApp: "dealership_web" });
    return result.data;
  } catch (error) {
    console.error("Error getting dealership members:", error);
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: "Error al obtener los miembros",
      error: error.message,
    };
  }
};

export const deleteDealershipMember = async (data) => {
  try {
    const fn = httpsCallable(functions, "deactivateUnitMembershipV2");
    const result = await fn({ ...data, requestedApp: "dealership_web" });
    return result.data;
  } catch (error) {
    console.error("Error deleting dealership member:", error);
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: "Error al eliminar el miembro",
      error: error.message,
    };
  }
};
